import React from "react";
import { useParams } from "react-router-dom";
import { RefundsTable } from "../../refunds/RefundsGrid";

function UserWithdraws() {
  const { userId } = useParams();
  const withdrawsApiUrl = `/api/v1/users/${userId}/withdrawals`;

  return <RefundsTable apiUrl={withdrawsApiUrl} />;
}

export default UserWithdraws;
